import { render, staticRenderFns } from "./TextItemRangeLimit.vue?vue&type=template&id=020abe63&"
import script from "./TextItemRangeLimit.vue?vue&type=script&lang=js&"
export * from "./TextItemRangeLimit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports